import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AuthProvider } from './contexts/AuthContext';
import { RequireAdmin } from './components/RequireAdmin';
import DashboardLayout from './layouts/DashboardLayout';
import LoginPage from './pages/LoginPage';
import DashboardHome from './pages/DashboardHome';
import ProductsPage from './pages/ProductsPage';
import OptionsPage from './pages/OptionsPage';
import CategoriesPage from './pages/CategoriesPage';
import CouponsPage from './pages/CouponsPage';
import DilimMilestonesPage from './pages/DilimMilestonesPage';
import PushNotificationsPage from './pages/PushNotificationsPage';
import StaffPage from './pages/StaffPage';
import UsersPage from './pages/UsersPage';
import DriversPage from './pages/DriversPage';
import CommentsPage from './pages/CommentsPage';
import DailyIncomePage from './pages/DailyIncomePage';
import TopSellersPage from './pages/TopSellersPage';
import OrdersPage from './pages/OrdersPage';
import RestaurantsPage from './pages/RestaurantsPage';
import TaxSettingsPage from './pages/TaxSettingsPage';
import PaymentSettingsPage from './pages/PaymentSettingsPage';
import ExpensesPage from './pages/ExpensesPage';
import IncomePage from './pages/IncomePage';
import AccountingSummaryPage from './pages/AccountingSummaryPage';
import MarketplaceBridgePage from './pages/MarketplaceBridgePage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAdmin />}>
            <Route element={<DashboardLayout />}>
              <Route index element={<DashboardHome />} />
              <Route path="/catalog/products" element={<ProductsPage />} />
              <Route path="/catalog/categories" element={<CategoriesPage />} />
              <Route path="/catalog/options" element={<OptionsPage />} />
              <Route path="/marketing/coupons" element={<CouponsPage />} />
              <Route path="/marketing/dilim-milestones" element={<DilimMilestonesPage />} />
              <Route path="/messaging/push" element={<PushNotificationsPage />} />
              <Route path="/operations/orders" element={<OrdersPage />} />
              <Route path="/operations/restaurants" element={<RestaurantsPage />} />
              <Route path="/operations/tax-settings" element={<TaxSettingsPage />} />
              <Route path="/operations/payment-settings" element={<PaymentSettingsPage />} />
              <Route path="/operations/marketplace-bridge" element={<MarketplaceBridgePage />} />
              <Route path="/people/staff" element={<StaffPage />} />
              <Route path="/people/users" element={<UsersPage />} />
              <Route path="/people/drivers" element={<DriversPage />} />
              <Route path="/feedback/comments" element={<CommentsPage />} />
              <Route path="/analytics/daily-income" element={<DailyIncomePage />} />
              <Route path="/analytics/top-sellers" element={<TopSellersPage />} />
              <Route path="/muhasebe/ozet" element={<AccountingSummaryPage />} />
              <Route path="/muhasebe/giderler" element={<ExpensesPage />} />
              <Route path="/muhasebe/gelirler" element={<IncomePage />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
